export default "__VITE_ASSET__DhUaBBbR__"